export default (state) => state.notificationCenter.inFocus
